import { Box } from '@mui/material';
import React from 'react';
import './title.scss';

const Title = ({title}) => {
    return (
      <div>
        <h3 className="text-white font-semibold letter-2">{title}</h3>
        <Box sx={{width:{xs:'40%',sm:'25%', md:'18%'}}} className="title"></Box>
      </div>
    );
};

export default Title;